export const MAX_PAGE_WIDTH_PX = 1080
export const MIN_PAGE_WIDTH_PX = 720
export const PAGE_GUTTER_PX = 60
